<template>
  <div class="pageContent scrollDiv" v-on:touchmove="loadPage" v-on:touchend="loadEnd">
    <mu-appbar slot="center">
      <router-link slot="left" to="/home/index">
        <mu-icon value="keyboard_arrow_left" color="white"/>
      </router-link>
      <span class="topT right" href="#/home/index">
        <a href="#/search/selectCity" style="color:white;left:10px;position:relative">
          {{g_city.name}}
          <mu-icon
            style="position:relative;top:2px;"
            :size="16"
            value="arrow_drop_down"
            color="white"
          />
        </a>
      </span>
      <mu-flat-button v-on:click="gomapSearch" label="地图找房" slot="right"/>
    </mu-appbar>
    <div style="width:100%" align="center">
      <mu-paper
        style="overflow:hidden ; width:92% ; margin:-10px auto  0.3rem auto ;   "
        align="center"
        :zDepth="1"
      >
        <!--<span style=" float:left ; padding: 0.45rem 0rem 0 0.3rem ; color:#666666 ">
                      入住时间 padding:0.15rem 0 0.1rem 0.5rem  ;  height:1.1rem ; color:#999 
        </span>-->
        <div style="position:relative;">
          <mu-date-picker
            format="YYYY-MM-DD"
            icon="date_range"
            v-model="g_searchParam.arriveDate"
            :maxDate="checkinMaxDate"
            :minDate="checkinMinDate"
            :underlineShow="false"
            @change="setRelaxDate"
            style=" float:left ; width: 2rem  ; over-flow:hidden"
            id="DateListToRelax"
          />
          <span
            style="    margin: auto 0; position: absolute; top: 1em; width: 2rem; left: 56px; z-index: 100;
              color: #666; margin-top:0.1rem"
          >{{arriveDateFormat}}</span>
        </div>

        <mu-dropDown-menu
          :value="relaxHour"
          @change="setRelaxHour"
          icon="search"
          id="TimeListToRelax"
          style="float: right  ; margin-right:0.2rem  ;  font-size:0.3rem ;  "
        >
          <!--<mu-dropDown-menu :value="relaxHour" @change="setRelaxHour" icon="search" iconClass="colorCCC" style="float:right ; width:3rem ; margin-top:-0.07rem" >-->
          <mu-menu-item value="11" title="11:00"/>
          <mu-menu-item value="12" title="12:00"/>
          <mu-menu-item value="13" title="13:00"/>
          <mu-menu-item value="14" title="14:00"/>
          <mu-menu-item value="15" title="15:00"/>
          <mu-menu-item value="16" title="16:00"/>
        </mu-dropDown-menu>
      </mu-paper>
    </div>

    <!--关键字搜索  -->
    <div class="searchDiv">
      <span @click="selectKey">
        <span class="icon">
          <mu-icon :size="19" value="search"/>
        </span>
        {{ this.g_searchKeyWord }}
      </span>
    </div>
    <!--// 排序  ：  综合0  好评3  距离2 价格1  Sorttype -->
    <!--<div class="kosmos-tabs">
            <mu-tabs :value="activeTab" @change="handleTabChange">
              <mu-tab value="0" title="综合" />
              <mu-tab value="3" title="好评" />
              <mu-tab value="2" title="距离" />
              <mu-tab value="1" title="价格" />
            </mu-tabs>
            <mu-divider/>
    </div>-->
    <mu-list class="hotelList" style="   ">
      <div v-if="IsLoading" style="text-align:center;margin:1rem 0 7rem 0;">
        <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ;">
      </div>

      <mu-list-item
        v-else
        v-for="item in HotelList"
        v-on:click="choose(item.HotelCode)"
        style="text-align:left; border-bottom: 1px solid #eeeeee; "
      >
        <!--酒店图片-->
        <div
          :style=" 'background: url('+ item.MiniPic + ')   ;   background-size:contain;  float:left ; width: 2rem ; height: 1.5rem;  font-size:0.18rem; min-height:0.7rem ; ' "
        >
          <div
            v-if="item.LabelTop "
            style="  position:absolute ; background-color:red; color:white; padding: 0 0.05rem"
          >{{ item.LabelTop }}</div>
          <div
            v-if="item.LabelBottom "
            style="text-align:center ;  top:1.3rem ;position:absolute  ; color:white; width: 2rem;height:0.32rem; background: url(static/search/pic_bg.png) repeat-x ;"
          >{{ item.LabelBottom }}</div>
        </div>

        <!--右边-->
        <div style="width:68%; float:right;margin-top:-0.08rem">
          <div
            style="font-weight:bold ; color:#777 ; font-size: 0.28rem; line-height:0.4rem; min-height:0.8rem"
          >
            {{ item.HotelName }}
            <span
              style="  "
              v-if="item.LabelBack"
              class="BackLabel"
            >{{ item.LabelBack}}</span>
          </div>

          <div
            style="height:0.4rem"
            v-if="item.ListGreen.length == 0  && item.ListYellow.length == 0   "
          ></div>

          <!--星星中间不能有空格，所以他们要放在一行-->
          <mu-icon
            value="star"
            color="#FF8F3B"
            :size="8"
            v-for="i in fullStar(item.CommentAveragePoint)"
          />
          <mu-icon
            style="position:relative;top:1px;"
            value="star_half"
            color="#FF8F3B"
            :size="8"
            v-if="halfStar(item.CommentAveragePoint)"
          />
          <mu-icon
            style="position:relative;top:1px;"
            value="star_outline"
            color="#FF8F3B"
            :size="8"
            v-for="i in nullStar(item.CommentAveragePoint)"
          />
          <!--星星中间不能有空格，所以他们要放在一行-->
          <span style=" margin-left:0.3rem ">
            <img
              v-for="ser in item.HotelServiceList"
              :src="'../../../static/service/' + serviceIcon(ser.KeyId) + '.png'"
              v-bind:class="serviceIcon(ser.KeyId)"
            >
          </span>
          
          <span class="lowestPrice" style=" " v-if="item.LowestPrice != '满房'">
            <span class="priceSign">￥</span>
            <span class="priceShow">{{item.LowestPrice}}</span>
            <span class="priceTxt">起</span>
          </span>
          <span class="lowestPrice" style=" " v-if="item.LowestPrice == '满房'">
            <span class="priceShow">{{item.LowestPrice}}</span>
          </span>

          <div style="font-size:0.18rem ; line-height:0.6rem ;  width:100% ">
            <span class="GreenLabel" v-if="  item.ListGreen[0]!=null  ">{{ item.ListGreen[0] }}</span>
            <span class="GreenLabel" v-if="  item.ListGreen[1]!=null  ">{{ item.ListGreen[1] }}</span>
            <span class="YelloLabel" v-if="  item.ListYellow[0]!=null  ">{{ item.ListYellow[0] }}</span>
            <span class="YelloLabel" v-if="  item.ListYellow[1]!=null  ">{{ item.ListYellow[1] }}</span>
          </div>
        </div>
      </mu-list-item>

      <div
        class="load"
        style=" background-color:#f5f5f5"
        v-if="!loadState && HotelList.length>=4"
      >{{ loadMsg }}</div>
      <div class="loading" v-if="loadState">
        <!--<mu-circular-progress :size="40"/>-->
        <img
          src="../../../static/LoadingWhite.gif"
          v-if="this.loadMsg == '加载中。。。'"
          style=" width:1.2rem ; margin: 0.5rem 0 0.5rem 0  "
        >
        <img
          src="../../../static/LoadingWhite.gif"
          style=" width:1.2rem ; margin: 0.2rem 0 0.2rem 0  "
          v-if="this.loadMsg == '加载中'"
        >
      </div>
    </mu-list>
  </div>
</template>

<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import service from "../../utils/hotelService.js";
import date from "../../utils/dateextend";
export default {
  data() {
    return {
      loadState: false,
      loadMsg: "加载中",
      // 顶部搜索
      relaxHour: "11",

      HotelList: [],
      activeTab: "0",

      PageIndex: 1,

      IsLoading: true,
        // 登录状态
      loginState: false,
    };
  },
  watch: {
    g_searchParam: {
      handler: function(val, oldVal) {
        // if(val.Sort == ''){
        this.change = true;
        // }
      },
      deep: true
    }
  },
  created() {
    var searchParam = this.g_searchParam;
    searchParam.Sort = 0;
    searchParam.arriveDate = new Date().Format("yyyy-MM-dd");
    searchParam.relaxHour="11";
    this.setG_searchParam(searchParam);
  },
  activated() {
    // console.log("-----------0---------")
    //  var searchParam = this.g_searchParam;
    //   searchParam.arriveDate = new Date().Format("yyyy-MM-dd");
    //   searchParam.relaxHour="11";
    //   console.log("========测试========")
    //   console.log(searchParam)
    //   this.setG_searchParam(searchParam);


    this.init();

    //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {     
      if (res.Result) {
        this.loginState = true
      }
      else {
      if (this.$route.query.cardNo!=undefined && this.$route.query.sign!=undefined) {
              this.loginState = false
              this.CheckLogin(); 
              this.setinitRelax();
        }
      }
    })     
  },



  methods: {
    ...mapMutations(["setG_currentInfo", "setG_searchParam","setG_UserInfo"]),
    // 排序  ：  综合0  好评3  距离2 价格1  Sorttype

    init() {
      this.PageIndex = 1;
      this.IsLoading = true;
      this.activeTab = "0";

      this.HotelList = [];

      // this.loadMsg = '加载中...'
      this.loadState = false;

      this.searchHotel();

      console.log(this.g_searchParam.relaxHour);

      if (parseInt(this.g_searchParam.relaxHour) > 16) this.relaxHour = "16";
      else this.relaxHour = this.g_searchParam.relaxHour;

      console.log("this.g_searchParam");
      console.log(this.g_searchParam);
    },

   // 检验是否登入，APP 小程序 跳转到该页面需要检索到自动登入 功能
    CheckLogin(){
     if (this.$route.query.cardNo!=undefined && this.$route.query.sign!=undefined) {
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.cardNo);
      params.append("sign", this.$route.query.sign);
 
      this.$http.post(api.CheckLoginState(), params.toParam()).then(data => {
        if(data.Result){ 
             // 自动登入成功--保存登录信息
            var result = data.Data
            this.SaveUserInfo(result)
            // var loginInfo = this.g_loginInfo
            // loginInfo.Card_no = res.Data.Card_no
            // this.setG_loginInfo(loginInfo)
          }
        });
        }
    },

   SaveUserInfo(result) {
      // 保存登录信息
      // 保存登录信息
      var UserInfo = result
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
       console.log(UserInfo)
      // 保存登录信息
      this.setG_UserInfo(UserInfo)
    },

    //  休闲房  setG_searchKeyWord
    searchHotel() {
      console.log(this.PageIndex);
      var params = new this.URLSearchParam();
      params.append("cityId", this.g_searchParam.cityId);
      params.append("hotelCode", this.g_searchParam.hotelCode);
      params.append("arriveDate", this.g_searchParam.arriveDate);
      params.append("relaxHour", this.g_searchParam.relaxHour);
      params.append("Isasc", "true");
      params.append("areaZoneId", this.g_searchParam.areaId); //   获取酒店
      // params.append('Sorttype', this.activeTab);
      // if (this.activeTab == 3) params.append('Isasc', "false");
      // else params.append('Isasc', "true");
      params.append("Sorttype", 0);
      params.append("Isasc", "true");
      params.append("lng", this.g_searchParam.lng);
      params.append("lat", this.g_searchParam.lat);
      params.append("hotPointId", this.g_searchParam.hotPointId);
      params.append("PageIndex", this.PageIndex);
      params.append("PageSize", this.g_searchParam.PageSize);
      this.$http
        .post(api.SearchRelaxHotelList(), params.toParam())
        .then(res => {
          if (res.Result) {
            if (res.Data.length == 10) {
              this.loadMsg = "上拉加载更多";
            } else {
              this.loadMsg = "没有更多记录";
            }
            var temp = res.Data;
            // 小图标
            temp.forEach(function(element) {
              element.HotelServiceList = new Object();

              if (element.serviceDicStr.HasBreakfast == "有") {
                let tmp = new Object();
                tmp.KeyId = "51";
                element.HotelServiceList[0] = tmp;
              }
              if (element.serviceDicStr.HasParking == "有") {
                let tmp = new Object();
                tmp.KeyId = "41";
                element.HotelServiceList[1] = tmp;
              }
              if (element.serviceDicStr.wifihavestr == "有") {
                let tmp = new Object();
                tmp.KeyId = "215";
                element.HotelServiceList[2] = tmp;
              }
              if (element.serviceDicStr.SpecialInvoice == "有") {
                let tmp = new Object();
                tmp.KeyId = "-1";
                element.HotelServiceList[3] = tmp;
              }
              if (element.serviceDicStr.SpecialInvoice3 == "有") {
                let tmp = new Object();
                tmp.KeyId = "-2";
                element.HotelServiceList[4] = tmp;
              }
              if (element.serviceDicStr.SpecialInvoice6 == "有") {
                let tmp = new Object();
                tmp.KeyId = "-3";
                element.HotelServiceList[5] = tmp;
              }
              if (element.serviceDicStr.HasSelfServiceMachine == "有") {
                let tmp = new Object();
                tmp.KeyId = "189";
                element.HotelServiceList[6] = tmp;
              }
            }, this);

            var HotelCodeList = "";

            temp.forEach(function(item) {
              item.ListGreen = [];
              item.ListYellow = [];

              if (HotelCodeList == "")
                HotelCodeList = HotelCodeList + item.HotelCode;
              else HotelCodeList = HotelCodeList + "|" + item.HotelCode;
            }, this);

            var params = new this.URLSearchParam();
            params.append("HotelCodeList", HotelCodeList);
            this.$http.post(api.GetHotelLabel(), params.toParam()).then(res => {
              let i = 0;

              temp.forEach(function(item) {
                item.ListLabel = res.Data.label[i];
                i++;

                // vue数组刷新  赋值，

                console.log(res.Data);

                item.ListLabel.forEach(function(ele) {
                  if (ele.LabelType == "首图顶部") {
                    // item.LabelTop = ele.LabelName;
                    this.$set(item, "LabelTop", ele.LabelName);
                  } else if (ele.LabelType == "首图底部") {
                    this.$set(item, "LabelBottom", ele.LabelName);
                  } else if (ele.LabelType == "店名后方") {
                    this.$set(item, "LabelBack", ele.LabelName);
                  } else if (ele.LabelType == "店名下方(定位类)") {
                    if (item.ListYellow == undefined) item.ListYellow = [];

                    item.ListYellow = item.ListYellow.concat(ele.LabelName);
                  } else if (ele.LabelType == "店名下方(评价类)") {
                    if (item.ListGreen == undefined) item.ListGreen = [];

                    item.ListGreen = item.ListGreen.concat(ele.LabelName);
                  }
                }, this);
              }, this);
            }, this);

            this.HotelList = this.HotelList.concat(temp);
            console.log(this.HotelList);

            this.PageIndex++;
            this.IsLoading = false;
            this.loadState = false;
          }
        });
    },

    // 下拉刷新数据
    loadPage() {
      var body = window.document.body;
      //滚动条滚动的距离
      var scrollTop = body.scrollTop;
      //文档可视区高度
      var clientHeight = window.document.documentElement.clientHeight;
      //滚动条高度
      var scrollHeight = body.scrollHeight;

      // console.log( 'x1x' +clientHeight )
      // console.log( 'x2x' +scrollTop )
      // console.log( 'x3x' +scrollHeight )

      // if (clientHeight + scrollTop >= scrollHeight) {

      if (this.loadMsg == "上拉加载更多") {
        this.loadMsg = "加载中。。。";
        this.loadState = true;
      }
      // }
    },

    loadEnd() {
      if (this.loadMsg == "加载中。。。") {
        this.loadMsg = "加载中";
        this.searchHotel();
      }
    },
    // 下拉刷新数据   END

  // 如果是外面直接跳转到该页面的，需要初始化时间 日期 城市
    setinitRelax() {
      var searchParam = this.g_searchParam;
      searchParam.arriveDate = new Date().Format("yyyy-MM-dd");
      searchParam.relaxHour="11";
      this.setG_searchParam(searchParam);
    },

    // 全日房  开始时间 如：11
    setRelaxHour(relaxHour) {
      this.relaxHour = relaxHour;
      var searchParam = this.g_searchParam;
      searchParam.relaxHour = relaxHour;
      this.setG_searchParam(searchParam);

      this.init();
    },

    // 排序的东西不需要了
    handleTabChange(val) {
      var searchParam = this.g_searchParam;
      searchParam.Sort = val;
      this.setG_searchParam(searchParam);
      console.log(val);
      this.init();
      this.activeTab = val;
    },
    selectKey() {
      this.$router.push({ path: "/search/key" });
    },

    fullStar(input) {
      return Math.floor(input);
    },
    nullStar(input) {
      return Math.floor(5 - input);
    },
    halfStar(input) {
      if (this.fullStar(input) == input) {
        return false;
      }
      return true;
    },
    choose(code) {
      var model = this.g_currentInfo;
      model.HotelCode = code;
      this.setG_currentInfo(model);
      this.$router.push({ path: "/search/homeListToRelax" });
    },

    //初始化日期
    initDate() {
      var nowDate = new Date();
      var inDate = nowDate.Format("yyyy-MM-dd"); //入住日期为当天
      var outDate = nowDate.DateAdd("d", 1).Format("yyyy-MM-dd"); //离店日期为明天
      this.reWriteQueryDate(inDate, outDate);
      this.reWriteQueryDate(inDate, outDate);
    },

    //检查时间是否超时（入住时间小于今天）
    checkDateOut() {
      if (this.g_searchParam.startDate == "") {
        this.initDate();
      } else {
        var day = date.daysBetween(
          new Date().Format("yyyy-MM-dd"),
          this.g_searchParam.startDate
        );
        if (day < 0) {
          this.initDate();
        }
      }
    },

    gomapSearch() {
      var searchParam = this.g_searchParam;
      searchParam.IsRelaxMap = true;
      this.setG_searchParam(searchParam);

      this.$router.push({ path: "/search/mapSearch" });
    },

    // 全日房得到入住日期
    setRelaxDate(arriveDate) {
      var searchParam = this.g_searchParam;
      searchParam.arriveDate = arriveDate;
      this.setG_searchParam(searchParam);
      this.init();
    },
    //获取url
    serviceIcon: service.serviceIcon
  },

  computed: {
    ...mapGetters([
      "g_city",
      "g_searchParam",
      "g_searchKeyWord",
      "g_currentInfo", 
      'g_UserInfo'
    ]),
    arriveDateFormat() {
      return new Date(this.g_searchParam.arriveDate).Format("M月D日");
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date();
    },
    checkinMaxDate() {
      //最大入住日期为3个月内
      return new Date().DateAdd("d", 89); //入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.startDate)
        .DateAdd("d", 1)
        .Format("yyyy-MM-dd");
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.startDate)
        .DateAdd("d", 14)
        .Format("yyyy-MM-dd");
    },
    day() {
      var d1 = new Date(this.g_searchParam.startDate);
      var d2 = new Date(this.g_searchParam.endDate);
      var s1 = d1.getTime(),
        s2 = d2.getTime();
      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
    }
  }
};
</script>



<style lang="less" scoped>
.BackLabel {
  font-size: 0.22rem;
  background-color: #27ba69;
  padding: 0.02rem 0.04rem;
  color: #fff;
  border-radius: 0.04rem;
  font-weight: normal;
}

// 圆角
.GreenLabel {
  background-color: #edf7f4;
  padding: 0.04rem 0.1rem;
  color: #6ca896;
  border-radius: 0.04rem;
}

.YelloLabel {
  background-color: #ffecdd;
  padding: 0.04rem 0.1rem;
  color: #ff8f38;
  border-radius: 0.04rem;
}
</style>


<style lang="less" scoped>
@import "../../assets/theme.less";
@import "../../assets/common.less";

#DateListToRelax {
  margin-left: 0.2rem;
  padding-top: 0.1rem;
  .mu-text-field-icon {
    float: left;
    color: #aaa;
  }
  .mu-text-field-input {
    padding-top: 0.15rem;
    position: absolute;
    width: 2rem;
  }
  .mu-text-field {
    margin-bottom: 0.1rem;
  }
}

#TimeListToRelax {
  margin-top: 0.05rem;
}

// .listTop {
//   padding: 0px;
//   .mu-text-field-input {
//     width: 2rem;
//     color: @secondBlack;
//     font-size: 0.28rem;
//     height: 18px;
//     top: 4px;
//     left: -0.5rem;
//   }
// }
.scrollDiv {
  height: auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f1f1f1;
  .mu-appbar {
    .mu-appbar-title {
      text-align: center;
      margin-top: -10px;
    }
  }
  .search-paper {
    height: 1.21rem;
    display: flex;
    display: -webkit-flex;
    margin-bottom: 0.2rem;
    div {
      width: 33%;
      display: inline-block;
      margin: auto;
      color: @secondBlack;
      font-size: 0.28rem;
      small {
        font-size: 0.22rem;
        color: @textColor;
        position: relative;
        top: 8px;
      }
    }
    .left {
      float: left;
    }
    .middle {
      span {
        color: @primaryOrange;
      }
    }
    .right {
      float: right;
    }
  }

  .divDivider {
    background-color: #f9f9f9;
    padding-bottom: 10px;
    clear: both;
  }
  .searchDiv {
    display: flex;
    display: -webkit-flex;
    color: @textColor;
    height: 0.81rem;
    font-size: 0.28rem;
    line-height: 0.39rem;
    span {
      margin: auto;
      height: 0.28rem;
      display: flex;
      display: -webkit-flex;
      .icon {
        height: 0.28rem;
        margin: auto;
      }
    }
    background-color: #fff;
    color: @textColor;
    margin-bottom: 10px;
  }

  .mu-tabs {
    margin-top: 5px;
    background-color: #fff;
    .mu-tab-link {
      color: @greyFontColor;
    }
    .mu-tab-active {
      color: @primaryColor;
    }
    .mu-text-field-line {
      background-color: #fff;
    }
  }

  .hotelList {
    background-color: #fff;
    padding: 0px;
    height: auto;
    .mu-item {
      .title {
        color: @secondBlack;
        font-size: 0.28rem;
        width: 4.75rem;
        overflow: hidden;
      }
      margin-bottom: 10px;
      margin-top: 10px;
      border-bottom: 1px solid #f1f1f1;
    }
    .mu-avatar img {
      border-radius: 0;
    }
    .mu-item .mu-avatar {
      height: 75px;
      width: 100px;
    }
    .mu-item.show-left {
      padding-left: 116px;
      padding-right: 6px;
      padding-top: 0px;
      padding-bottom: 10px;
    }
    .mu-item-left {
      width: 100px;
      left: 6px;
    }
    .mu-item-title {
      color: #666666;
      font-size: 90%;
    }
    .hotelLoc {
      color: @textColor;
      font-size: 0.22rem;
    }
    .lowestPrice {
      position: absolute;
      right: 0;
      margin-top: -3%;

      font-size: 0.22rem;
      .priceSign {
        color: @primaryOrange;
      }
      .priceShow {
        color: @primaryOrange;
        font-size: 0.36rem;
      }
      .priceTxt {
        color: @textColor;
      }
      padding-right: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ListToRelax.vue?247b05d9